/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BaselineEntity } from './BaselineEntity';
import {
    BaselineEntityFromJSON,
    BaselineEntityFromJSONTyped,
    BaselineEntityToJSON,
    BaselineEntityToJSONTyped,
} from './BaselineEntity';
import type { AssetEntity } from './AssetEntity';
import {
    AssetEntityFromJSON,
    AssetEntityFromJSONTyped,
    AssetEntityToJSON,
    AssetEntityToJSONTyped,
} from './AssetEntity';
import type { BaselineException } from './BaselineException';
import {
    BaselineExceptionFromJSON,
    BaselineExceptionFromJSONTyped,
    BaselineExceptionToJSON,
    BaselineExceptionToJSONTyped,
} from './BaselineException';

/**
 * 
 * @export
 * @interface AssetBaselineMapping
 */
export interface AssetBaselineMapping {
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssetBaselineMapping
     */
    discoveredAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetBaselineMapping
     */
    lastSeenAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetBaselineMapping
     */
    decommissionedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    status?: AssetBaselineMappingStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AssetBaselineMapping
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetBaselineMapping
     */
    extendedAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof AssetBaselineMapping
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetBaselineMapping
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    updatedBy?: string;
    /**
     * 
     * @type {AssetEntity}
     * @memberof AssetBaselineMapping
     */
    asset?: AssetEntity;
    /**
     * 
     * @type {BaselineEntity}
     * @memberof AssetBaselineMapping
     */
    baseline?: BaselineEntity;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    assignmentMethod?: AssetBaselineMappingAssignmentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    assignedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssetBaselineMapping
     */
    assignedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    assignmentRuleId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    inheritedFromBoundaryId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    inheritedFromAssetId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetBaselineMapping
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AssetBaselineMapping
     */
    effectiveDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetBaselineMapping
     */
    expirationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetBaselineMapping
     */
    complianceStatus?: AssetBaselineMappingComplianceStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AssetBaselineMapping
     */
    complianceScore?: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetBaselineMapping
     */
    lastAssessedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof AssetBaselineMapping
     */
    totalConfigItems?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetBaselineMapping
     */
    compliantItems?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetBaselineMapping
     */
    nonCompliantItems?: number;
    /**
     * 
     * @type {Array<BaselineException>}
     * @memberof AssetBaselineMapping
     */
    exceptions?: Array<BaselineException>;
    /**
     * 
     * @type {boolean}
     * @memberof AssetBaselineMapping
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssetBaselineMapping
     */
    decommissioned?: boolean;
}


/**
 * @export
 */
export const AssetBaselineMappingStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Decommissioned: 'DECOMMISSIONED',
    Deleted: 'DELETED'
} as const;
export type AssetBaselineMappingStatusEnum = typeof AssetBaselineMappingStatusEnum[keyof typeof AssetBaselineMappingStatusEnum];

/**
 * @export
 */
export const AssetBaselineMappingAssignmentMethodEnum = {
    Automatic: 'AUTOMATIC',
    Manual: 'MANUAL',
    Inherited: 'INHERITED'
} as const;
export type AssetBaselineMappingAssignmentMethodEnum = typeof AssetBaselineMappingAssignmentMethodEnum[keyof typeof AssetBaselineMappingAssignmentMethodEnum];

/**
 * @export
 */
export const AssetBaselineMappingComplianceStatusEnum = {
    Compliant: 'COMPLIANT',
    NonCompliant: 'NON_COMPLIANT',
    Partial: 'PARTIAL',
    NotAssessed: 'NOT_ASSESSED',
    Exception: 'EXCEPTION'
} as const;
export type AssetBaselineMappingComplianceStatusEnum = typeof AssetBaselineMappingComplianceStatusEnum[keyof typeof AssetBaselineMappingComplianceStatusEnum];


/**
 * Check if a given object implements the AssetBaselineMapping interface.
 */
export function instanceOfAssetBaselineMapping(value: object): value is AssetBaselineMapping {
    return true;
}

export function AssetBaselineMappingFromJSON(json: any): AssetBaselineMapping {
    return AssetBaselineMappingFromJSONTyped(json, false);
}

export function AssetBaselineMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetBaselineMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : (new Date(json['discoveredAt'])),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'version': json['version'] == null ? undefined : json['version'],
        'extendedAttributes': json['extendedAttributes'] == null ? undefined : json['extendedAttributes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'asset': json['asset'] == null ? undefined : AssetEntityFromJSON(json['asset']),
        'baseline': json['baseline'] == null ? undefined : BaselineEntityFromJSON(json['baseline']),
        'assignmentMethod': json['assignmentMethod'] == null ? undefined : json['assignmentMethod'],
        'assignedBy': json['assignedBy'] == null ? undefined : json['assignedBy'],
        'assignedAt': json['assignedAt'] == null ? undefined : (new Date(json['assignedAt'])),
        'assignmentRuleId': json['assignmentRuleId'] == null ? undefined : json['assignmentRuleId'],
        'inheritedFromBoundaryId': json['inheritedFromBoundaryId'] == null ? undefined : json['inheritedFromBoundaryId'],
        'inheritedFromAssetId': json['inheritedFromAssetId'] == null ? undefined : json['inheritedFromAssetId'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
        'complianceStatus': json['complianceStatus'] == null ? undefined : json['complianceStatus'],
        'complianceScore': json['complianceScore'] == null ? undefined : json['complianceScore'],
        'lastAssessedAt': json['lastAssessedAt'] == null ? undefined : (new Date(json['lastAssessedAt'])),
        'totalConfigItems': json['totalConfigItems'] == null ? undefined : json['totalConfigItems'],
        'compliantItems': json['compliantItems'] == null ? undefined : json['compliantItems'],
        'nonCompliantItems': json['nonCompliantItems'] == null ? undefined : json['nonCompliantItems'],
        'exceptions': json['exceptions'] == null ? undefined : ((json['exceptions'] as Array<any>).map(BaselineExceptionFromJSON)),
        'active': json['active'] == null ? undefined : json['active'],
        'decommissioned': json['decommissioned'] == null ? undefined : json['decommissioned'],
    };
}

export function AssetBaselineMappingToJSON(json: any): AssetBaselineMapping {
    return AssetBaselineMappingToJSONTyped(json, false);
}

export function AssetBaselineMappingToJSONTyped(value?: AssetBaselineMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'discoveredAt': value['discoveredAt'] == null ? undefined : ((value['discoveredAt']).toISOString()),
        'lastSeenAt': value['lastSeenAt'] == null ? undefined : ((value['lastSeenAt']).toISOString()),
        'decommissionedAt': value['decommissionedAt'] == null ? undefined : ((value['decommissionedAt']).toISOString()),
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'status': value['status'],
        'version': value['version'],
        'extendedAttributes': value['extendedAttributes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'asset': AssetEntityToJSON(value['asset']),
        'baseline': BaselineEntityToJSON(value['baseline']),
        'assignmentMethod': value['assignmentMethod'],
        'assignedBy': value['assignedBy'],
        'assignedAt': value['assignedAt'] == null ? undefined : ((value['assignedAt']).toISOString()),
        'assignmentRuleId': value['assignmentRuleId'],
        'inheritedFromBoundaryId': value['inheritedFromBoundaryId'],
        'inheritedFromAssetId': value['inheritedFromAssetId'],
        'isActive': value['isActive'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate']).toISOString()),
        'expirationDate': value['expirationDate'] == null ? undefined : ((value['expirationDate']).toISOString()),
        'complianceStatus': value['complianceStatus'],
        'complianceScore': value['complianceScore'],
        'lastAssessedAt': value['lastAssessedAt'] == null ? undefined : ((value['lastAssessedAt']).toISOString()),
        'totalConfigItems': value['totalConfigItems'],
        'compliantItems': value['compliantItems'],
        'nonCompliantItems': value['nonCompliantItems'],
        'exceptions': value['exceptions'] == null ? undefined : ((value['exceptions'] as Array<any>).map(BaselineExceptionToJSON)),
        'active': value['active'],
        'decommissioned': value['decommissioned'],
    };
}

